// extracted by mini-css-extract-plugin
export default {"content":"choose_content__MdNnV","pay":"choose_pay__pUEHN"};